import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { BaseService } from './base.service';
import { MessageService } from './message.service';
import { Observable } from 'rxjs';

@Injectable()
export class IBSCBSService extends BaseService {

  constructor(private http: HttpClient, private message: MessageService) { super(); }

  buscarCst(doc: 'nfe' | 'nfs' | 'todos'): Observable<CstIBSCBSViewModel[]> {
    return this.http.post(this.UrlService + `IBSCBS/BuscarCst`, { doc })
      .pipe(map(super.extractData), catchError(super.serviceError));
  }

  buscarCClassTrib(): Observable<CClassTribViewModel[]> {
    return this.http.get(this.UrlService + `IBSCBS/BuscarCClassTrib`)
      .pipe(map(super.extractData), catchError(super.serviceError));
  }
}

export interface CClassTribViewModel {
  cst: string;
  cClassTrib: string;
  nome: string ;
  ind_gTribRegular?: boolean;
  indNFe?: boolean;
  indNFSe?: boolean;
  pRedIBS?: number;
  pRedCBS?: number;
}

export interface CstIBSCBSViewModel {
  cst: string;
  descricao: string;
  ind_gIBSCBS?: boolean;
  ind_gRed?: boolean;
  ind_gDif?: boolean;
  ind_gTransfCred?: boolean;
}
